/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createPagingResponseOfHccAllotmentFromDiscriminatorValue, createValidationProblemDetailsFromDiscriminatorValue, serializeAgGridClientQuery, serializePagingResponseOfHccAllotment, type AgGridClientQuery, type PagingResponseOfHccAllotment, type ValidationProblemDetails } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Allotment/GetForHcc
 */
export interface GetForHccRequestBuilder extends BaseRequestBuilder<GetForHccRequestBuilder> {
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PagingResponseOfHccAllotment>}
     * @throws {ValidationProblemDetails} error when the service returns a 400 status code
     */
     post(body: AgGridClientQuery, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<PagingResponseOfHccAllotment | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: AgGridClientQuery, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const GetForHccRequestBuilderUriTemplate = "{+baseurl}/Allotment/GetForHcc";
/**
 * Metadata for all the requests in the request builder.
 */
export const GetForHccRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: GetForHccRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPagingResponseOfHccAllotmentFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeAgGridClientQuery,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
